import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelAccommodationAssignmentEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelAccommodationAssignmentEntity
